import { render } from "./CongratulationsScreen.vue?vue&type=template&id=4b5f1b66&scoped=true"
import script from "./CongratulationsScreen.vue?vue&type=script&lang=js"
export * from "./CongratulationsScreen.vue?vue&type=script&lang=js"

import "./CongratulationsScreen.vue?vue&type=style&index=0&id=4b5f1b66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5f1b66"]])

export default __exports__